/**
 * Device detection utilities
 */

/**
 * Detects if the current device is likely a mobile/touch device
 * @returns true if mobile/touch device detected
 */
export const isMobileDevice = (): boolean => {
  if (typeof window === "undefined") return false

  // Check for touch support
  const hasTouchScreen = "ontouchstart" in window || navigator.maxTouchPoints > 0

  // Check user agent for mobile indicators
  const userAgent = navigator.userAgent.toLowerCase()
  const mobileKeywords = [
    "android",
    "webos",
    "iphone",
    "ipad",
    "ipod",
    "blackberry",
    "windows phone",
    "mobile",
  ]
  const isMobileUserAgent = mobileKeywords.some((keyword) => userAgent.includes(keyword))

  // Check screen size (consider devices with width <= 768px as mobile)
  const isSmallScreen = window.innerWidth <= 768

  return hasTouchScreen && (isMobileUserAgent || isSmallScreen)
}

/**
 * Detects if the current device supports touch
 * @returns true if touch is supported
 */
export const isTouchDevice = (): boolean => {
  if (typeof window === "undefined") return false
  return "ontouchstart" in window || navigator.maxTouchPoints > 0
}
